import { useEffect } from 'react';
import { useAppDispatch } from 'src/hooks';
import { setNotificationData } from './store/notifications-slice';
import { BASE_WSS_URL_FLAT  } from 'src/constants';


export default function useNotificationWebSocket() {
  const appDispatch = useAppDispatch();

  useEffect(() => {
    // Establish WebSocket connection
    // Get the current host and protocol
    //const { protocol, host } = window.location;

    // Construct the WebSocket URL with the relative API path
    // const socketUrl = `${
    //   protocol === 'https:' ? 'wss' : 'ws'
    // }://${host}/api/ws/notifications/user/`;

    const socketUrl = `${BASE_WSS_URL_FLAT}/api/ws/notifications/user/`;

    console.log('socketUrl -- > ', socketUrl)

    // Establish WebSocket connection
    // Uncomment below line for local development
    //const socket = new WebSocket('ws://localhost:8001/api/ws/notifications/user/');
    const socket = new WebSocket(socketUrl);

    // Listen for messages
    socket.onmessage = (event) => {
      try {
        const notifications = JSON.parse(event.data);
        if (notifications && typeof notifications !== 'string'){
          if (notifications?.notifications && notifications.notifications.length) {
            appDispatch(
              setNotificationData({
                notificationData: notifications
              })
            );
          }
        }
      } catch (e) {
        console.error('Error while parsing the data', e);
      }

      // Handle the received message here
    };

    // Clean up the WebSocket connection
    return () => {
      if(socket.readyState==WebSocket.OPEN){
        socket.close();
      }
//      socket.close();
    };
  }, []);
}
